import React, { Component } from 'react'
import NotificationSystem from 'react-notification-system'
import { initNotificationSystem } from '../actions'
import { dispatch } from '../helpers/store'

export default class Notifications extends Component {
  componentDidMount() {
    dispatch(initNotificationSystem(this.refs.notificationSystem))
  }

  render() {
    return <NotificationSystem ref='notificationSystem' style={style} />
  }
}

const style = {
  NotificationItem: {
    DefaultStyle: {
      padding: '1rem',
    },
    error: {
      backgroundColor: 'rgba(0, 0, 0, .75)',
      color: '#e61600',
      border: 0,
      borderRadius: '.25rem',
      boxShadow: '0 .5rem .25rem rgba(0, 0, 0, .75)',
    }
  },
  Dismiss: {
    error: {
      color: '#fff',
      backgroundColor: '#000'
    }
  }
}


// WEBPACK FOOTER //
// app/javascript/src/components/notifications.jsx